import useLocale from 'next-translate/useTranslation';

import clsxm from '@/lib/clsxm';

import { tone } from './primitives';

// The file names are historical; each comment says which company it is.
import GeLogo from '~/svg/Barwenock.svg'; // GE
import TakashimayaLogo from '~/svg/Bengs.svg'; // Takashimaya
import LalamoveLogo from '~/svg/Lalamove.svg'; // Lalamove
import BniLogo from '~/svg/Stripe.svg'; // BNI
import SephoraLogo from '~/svg/Supabase.svg'; // Sephora
import PwcLogo from '~/svg/Tailwind.svg'; // PwC
import RazorpayLogo from '~/svg/Typescript.svg'; // Razorpay

// Sized from each file's aspect ratio (explicit width AND height: an inline
// SVG without them collapses in a flex row), tuned by eye so wordmarks and
// monograms read the same size.
const LOGOS = [
  { name: 'GE', Logo: GeLogo, className: 'h-10 w-10' },
  { name: 'PwC', Logo: PwcLogo, className: 'h-9 w-[47px]' },
  { name: 'Sephora', Logo: SephoraLogo, className: 'h-[15px] w-[116px]' },
  { name: 'BNI', Logo: BniLogo, className: 'h-7 w-[73px]' },
  { name: 'Razorpay', Logo: RazorpayLogo, className: 'h-6 w-[114px]' },
  {
    name: 'Takashimaya',
    Logo: TakashimayaLogo,
    className: 'h-[22px] w-[124px]',
  },
  { name: 'Lalamove', Logo: LalamoveLogo, className: 'h-8 w-[114px]' },
];

export default function AgentLogos() {
  const { t } = useLocale('chatbots');

  return (
    <section className='mx-auto max-w-7xl px-6 pb-8 pt-16 sm:pt-20 lg:px-8'>
      <p
        className={clsxm(
          'text-center text-sm font-medium tracking-normal',
          tone.quiet,
        )}
      >
        {t('Used by teams at')}
      </p>
      <ul className='mt-8 grid grid-cols-2 items-center gap-x-8 gap-y-10 sm:grid-cols-4 lg:flex lg:justify-between'>
        {LOGOS.map(({ name, Logo, className }) => (
          <li key={name} className='flex justify-center'>
            <Logo
              role='img'
              aria-label={name}
              className={clsxm(
                'flex-none opacity-55 grayscale transition duration-300 hover:opacity-90 dark:opacity-60 dark:invert dark:hover:opacity-90',
                className,
              )}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
